module.exports = __webpack_public_path__ + "img/product_chart_5.e043d2f9.png";